import script from "./SelectionComposer.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectionComposer.vue?vue&type=script&setup=true&lang=ts"

import "./SelectionComposer.vue?vue&type=style&index=0&id=f21cfb88&lang=css"

const __exports__ = script;

export default __exports__